import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { inLastStep } from '../../selectors/ui';
import { getOrderTotal } from '../../selectors/cart';
import Marketing from './Marketing';
import { getLoadedListingSlug } from '../../selectors/ui';

class EmbedMarketing extends Marketing {
  embedPort = null;

  reportEvent = (type, args = {}) => {
    if (this.props.isEmbed) {
      args.action = type;
      args.eventId = this.props.eventIds[0];
      args.listingSlug = this.props.listingSlug;
      this.embedPort.postMessage(args);
    }
  }

  constructor(props) {
    super(props);

    this.localStoragePrefix = 'EmbedMarketing_onReservationComplete_';
    
    if (props.isEmbed) {
      // subscribe to hooks
      this.props.addCouponSubmissionHook(this.onCouponSubmitted);
      this.props.addReservationStartHook(this.onReservationStart);
      this.props.addReservationCompleteHook(this.onReservationComplete);
      this.props.addReservationClearHook(this.onReservationClear);
      this.props.addReservationExpiresInHook(this.onReservationExpiresIn);
      this.props.addTicketsAddedToCartHook(this.onTicketsAdded);
      this.props.addProductsAddedToCartHook(this.onProductsAdded);
      this.props.addBundlesAddedToCartHook(this.onBundlesAdded);
      this.props.addTicketsRemovedFromCartHook(this.onTicketsRemoved);
      this.props.addProductsRemovedFromCartHook(this.onProductsRemoved);
      this.props.addBundlesRemovedFromCartHook(this.onBundlesRemoved);
      this.props.addStateTransitionHook(this.onStateTransition);
      this.props.addInsuranceOptionChangedHook(this.onInsuranceOptionChanged);
      this.props.addCartTimerExtendedHook(this.onCartTimerExtended);      
      let channel = new MessageChannel();
      this.embedPort = channel.port1;
      this.embedPort.onmessage = this.messageReceived;
      window.top.postMessage("embedPort", window.top.location, [channel.port2]);
    }

    this.state = {
      canSendExpiredEvent: true,
      lastInsuranceEvent: null,
    }
  }

  messageReceived = (e) => {
    console.log("Message received from window", e.data);
  }

  componentWillUnmount() {
    this.throttledReportCartExpiredEvent.clearTimeout();
  }
}

const mapStateToProps = state => {
  const eventIds = state.event.childEvent ? [state.event.childEvent.event_id] : Object.keys(state.event.events);
  return {
    payments: state.payment.payments,
    confirmationNumber: state.reservation.confirmation_number,
    inLastStep: inLastStep(state),
    currency: state.reservation.currency || 'USD',
    orderTotal: getOrderTotal(state)?.amount ?? 0,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    bundleSales: state.bundleSales.bundles,
    isEmbed: !!state.ui.isEmbed,
    eventIds: eventIds,
    listingSlug: getLoadedListingSlug(state),
    insurance: state.insurance
  }
}

const mapDispatchToProps = dispatch => {
  const actions = {};
  Object.keys(hookActions).forEach(hookActionName => {
    actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
}

EmbedMarketing.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedMarketing)
